import { EntityReference } from '../../core/api/api.entities';
import { FormOptions } from './base.form-options';

export class ShoppingItemFormOptions extends FormOptions {
  locations: EntityReference[] = [];
}
